import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import { RuleFilterDateFields } from '../constants/createSegment';

export const titleCase = input => {
  if (!input || typeof input !== 'string') {
    return '';
  }
  const [first, ...remaining] = input.split('');
  const result = first.toUpperCase() + remaining?.join('');
  return result;
};

export const getEpochTime = dateString => {
  if (isEmpty(dateString)) {
    return -1;
  }

  const [day, month, year] = dateString.trim().split('/');
  const date = new Date(+year, month - 1, +day);

  return date.getTime();
};

export const stringFormatter = value => {
  return isEmpty(value) ? '-' : value;
};

export const formatDateFields = formData => {
  if (isEmpty(formData)) {
    return {};
  }

  RuleFilterDateFields?.forEach(field => {
    formData[field] = epochToDateString(formData[field]);
  });
  return formData;
};

export const epochToDateString = epochDate => {
  if (isNull(epochDate)) {
    return '-';
  }
  try {
    const date = new Date(0);
    date.setUTCSeconds(epochDate);
    return date.toISOString()?.split('T')?.[0];
  } catch {
    return '-';
  }
};

export const getSegmentById = (segmentId, segmentList) => {
  if (isEmpty(segmentList) || isEmpty(segmentId)) {
    return {};
  }

  return segmentList?.find(segment => segment?.segmentIdentifier?.segmentId === segmentId);
};

export const getKeyByValue = (object, value) => {
  return Object.keys(object)?.find(key => object[key] === value);
};

/**
 * Method to check if a string contains a given search text
 * @param searchStr
 * @param searchText
 * @returns {boolean}
 */
export const containsSubstring = (searchStr, searchText) => {
  return searchStr?.toLowerCase().includes(searchText?.toLowerCase());
}